import * as action_types from "./constants";
import { UnitsTableType } from "./types";

export type myTeamState = {
  unitsData: {
    loader: boolean;
    data: UnitsTableType[] | null;
  };
};

const initialState: myTeamState = {
  unitsData: {
    loader: true,
    data: null,
  },
};

interface ApiPayload {
  data: UnitsTableType[];
  count: number;
}

const myTeamReducer = (
  state = initialState,
  action: { type: string; payload: { data: ApiPayload; loading: boolean } }
) => {
  const { type, payload } = action;
  switch (type) {
    case action_types.UNIT_LISTING:
      return {
        ...state,
        unitsData: {
          loader: payload?.loading || false,
          data: payload?.data?.data,
        },
      };

    default:
      return state;
  }
};

export default myTeamReducer;
